/**
 * class helper
 * @module class-helper
 */

var classHelper = (function() {
  var hasClass = function(el, className) {
    return el.classList
      ? el.classList.contains(className)
      : new RegExp('\\b' + className + '\\b').test(el.className);
  };

  var addClass = function(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!hasClass(el, className)) el.className += ' ' + className;
  };

  var removeClass = function(el, className) {
    if (el.classList) el.classList.remove(className);
    else
      el.className = el.className.replace(
        new RegExp('\\b' + className + '\\b', 'g'),
        ''
      );
  };

  var toggleClass = function(el, className) {
    // Our function to toggle classes without jQuery, it takes two parameters:
    // 1. The element to have a class toggled
    // 2. The name of the class we want to toggle
    // Check if the element exists,
    // & if it has the class we want to toggle
    if (el && el.className && el.className.indexOf(className) >= 0) {
      // Element has the class, so lets remove it...
      // Find the class to be removed (including any white space around it)
      var pattern = new RegExp('\\s*' + className + '\\s*');
      // Replace that search with white space, therefore removing the class
      el.className = el.className.replace(pattern, ' ');
    } else if (el) {
      // Element doesn't have the class, so lets add it...
      el.className = el.className + ' ' + className;
    } else {
      // Our element doesn't exist
      console.log('Element not found');
    }
  };

  return {
    hasClass: hasClass,
    addClass: addClass,
    removeClass: removeClass,
    toggleClass: toggleClass
  };
})();

module.exports = classHelper;



// WEBPACK FOOTER //
// ./helpers/class-helper.js